import React from 'react'

import { createStackNavigator } from '@react-navigation/stack'
import {
  View,
  StyleSheet,
  Image
} from 'react-native'
import {
  adaptive,
  theme,
  typography
} from '@sart/styles'
import { useContent } from '@sart/content'

import { stackNavigationProps } from '../nagivationProps'

import CommunityHome from './CommunityHome'

const Stack = createStackNavigator()

function CommunityStackNavigator() {

  const content = useContent()

  return (
    <Stack.Navigator
      initialRouteName='CommunityHome'
      screenOptions={{
        headerTitleAlign: 'center',
        ...stackNavigationProps.screenOptions
      }}
    >
      <Stack.Screen
        name="Community"
        component={CommunityHome}
        options={{
          headerTitleStyle: theme.navigationHeader,
          headerLeft: () => (<View style={{paddingLeft: 15, marginTop:0}}>
            <Image
                source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
                height={45} width={45}
            />
          </View>
          ),
          headerTopInsetEnabled:true
        }}
      />
    </Stack.Navigator>
  )
}

export default CommunityStackNavigator

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
  },
  description: {
    textAlign: 'center'
  },
  itemStyle: {
    ...typography.lightbold
  },
  itemViewStyle: {
    flex: 1
  },
  itemHeaderStyle: {
    ...theme.navigationItemHeader,
  }
})